// extracted by mini-css-extract-plugin
export default {"link":"Ikn7zx","image":"BJSaf1","root":"LjV9wd"};